import { render } from "./MovesPage.vue?vue&type=template&id=934c22c2&scoped=true"
import script from "./MovesPage.vue?vue&type=script&lang=js"
export * from "./MovesPage.vue?vue&type=script&lang=js"

import "./MovesPage.vue?vue&type=style&index=0&id=934c22c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-934c22c2"]])

export default __exports__